export var GalleryLayout;
(function (GalleryLayout) {
    GalleryLayout["CAROUSEL"] = "carousel";
    GalleryLayout["GRID"] = "grid";
})(GalleryLayout || (GalleryLayout = {}));
